import script from "./DeleteTaskModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteTaskModal.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteTaskModal.vue?vue&type=style&index=0&id=83221dfe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83221dfe"]])

export default __exports__